module.exports = __webpack_public_path__ + "assets/f2840a8389cddcd8907112a6770b4a0a.eot";